<template>
  <b-avatar-group size="35px"   v-if="signers.length">
    <div class="text-center w-full">
    <b-avatar
      v-for="(item, index) in signers"
      :key="index"
      badge badge-right
      variant="primary"
      :badge-variant="item.variant"
      :text="item.userInitials"
      :src="item.avatar"
      v-b-popover.hover.top="item.name"
    >
      <template #badge><b-icon :icon="item.icon"></b-icon></template>
    </b-avatar>
  </div>
  </b-avatar-group>
  <div class="text-center w-full" v-else>
    <span >N/A</span>
  </div>
</template>

<script>
// Utils
import commonsApi from '@/api/commons'

export default {
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      signers: []
    }
  },
  methods: {
    async loadSignersAvatars () {
      for (const [index, item] of this.value.signers.entries()) {
        const res = await commonsApi.axiosGetWrapper(`/users/user-meta/${item.id}`)
        const userInfo = res.data
        let signer = {}

        let variant = index < this.value.signatures ? 'success' : 'danger'
        let icon = index < this.value.signatures ? 'check' : 'dash-circle'
        if (typeof item.done === 'boolean') {
          variant = item.done ? 'success' : 'danger'
          icon = item.done ? 'check' : 'dash-circle'
        }
        if (userInfo) {
          signer = {
            name: `${userInfo.firstname} ${userInfo.lastname}`,
            userInitials: res.data?.userInitials,
            avatar: userInfo?.profilePicture || '',
            variant: variant,
            icon: icon
          }
        } else {
          signer = {
            name: item.name,
            variant: variant,
            icon: icon
          }
        }
        this.signers.push(signer)
      }
    }
  },
  async created () {
    try {
      await this.loadSignersAvatars()
    } catch (error) {
      console.log(error)
    }
  }
}
</script>
